<script>
import { mapGetters } from 'vuex'
import getSymbolFromCurrency from 'currency-symbol-map'
import VueMultiselect from 'vue-multiselect'
import AppClose from '../common/app-close.vue'

export default {
  name: 'app-header-filter__field',
  components: { AppClose, VueMultiselect },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    currency: String,
    isMobileVersion: Boolean,
    searchParams: Array,
    autocompleteItems: [Array, Object],
  },

  data() {
    return {
      value: this.searchParams.find((param) => String(this.item.id) in param) 
        ? this.searchParams.find((param) => String(this.item.id) in param)[this.item.id] 
        : null,
      isShowField: false
    }
  },

  watch: {
    value() {
      this.$emit('changeValue', { [this.item.id]: this.value })
    }
  },

  methods: {
    valueToNumber(value) {
      return value.replace(/[^\d]/g, '')
    },
    formatNumber(e) {
      if (!this.value) {
        this.value = {}
      }
      const tmp = { ...this.value }
      const numberValue = this.valueToNumber(e.target.value)
      const { position } = e.target.dataset
      if (!this.item.isPrice) {
        e.target.value = numberValue

        const value = e.target.value.replace(/[^0-9]/g, '')
        if (value) {
          e.target.value = Number(value).toLocaleString()
        }

        tmp[position] = value
      } else {
        e.target.value = numberValue
          ? Number(numberValue)
            .toLocaleString()
            .split(',')
            .join(' ')
          : ''
        tmp[position] = e.target.value
      }
      this.value = tmp
      const isFromMoreTo = (
        position === 'from'
        && tmp['to']
        && Number(this.valueToNumber(tmp[position])) > Number(this.valueToNumber(tmp['to']))
      )
      const isToLessFrom = (
        position === 'to'
        && tmp['from']
        && Number(this.valueToNumber(tmp[position])) < Number(this.valueToNumber(tmp['from']))
      )
      if (!(isFromMoreTo || isToLessFrom) || !tmp['from'] || !tmp['to']) {
        this.onChangeInput()
      }
    },

    toggleShowField() {
      this.isShowField = !this.isShowField
    },

    closeOption(e) {
      const isClosestNumberInput = e.target.closest && e.target?.closest('.ww-range')
      const isNumberInput = this.$refs.numberInput?.contains(e.target)

      if (!isNumberInput && !isClosestNumberInput) {
        this.isShowField = false
      }
    },
    onOpenAutocomplete() {
      document.dispatchEvent(new Event('openAutocomplete'))
    },
    onChangeInput() {
      this.$emit('changeValue', { [this.item.id]: this.value }, true)
    },
    onSelect(value) {
      this.$emit('changeValue', { [this.item.id]: value }, true)
    },
    onRemove() {
      this.$emit('changeValue', { [this.item.id]: '' }, true)
    },
  },

  computed: {
    ...mapGetters({
      getCatalogConstantTranslationByKey: 'account/getCatalogConstantTranslationByKey',
      getTranslatedParam: 'account/getTranslatedParam',
    }),
    defaultValue() {
      if (this.isNumber) {
        return {
          from: null,
          to: null
        }
      }
      if (this.isText) {
        return ''
      }
      return null
    },
    fromConstant() {
      return this.getCatalogConstantTranslationByKey('from')
    },
    toConstant() {
      return this.getCatalogConstantTranslationByKey('to')
    },
    type() {
      return this.item.type
    },
    isSelect() {
      return this.type === 'select' || this.type === 'multiselect'
    },
    isText() {
      return this.type === 'text' || this.type === 'textarea'
    },
    isNumber() {
      return this.type === 'number'
    },
    enums() {
      return Object.entries(this.item.enums).map(([id, value]) => ({ id, value }))
    },
    currencySymbol() {
      return getSymbolFromCurrency(this.currency)
    },
    numberFilterPlaceholder() {
      const nameParam = this.getTranslatedParam(this.item.name)
      const { from, to } = this.value
      
      const fromSubstr = from ? `${this.fromConstant} ${from}` : ''
      const toSubstr = to ? `${this.toConstant} ${to}` : ''
      const placeholder = (fromSubstr || toSubstr) ? `${fromSubstr} ${toSubstr} (${nameParam.toLowerCase()})` : nameParam

      return placeholder
    }
  },

  created() {
    if (this.isNumber && !this.value) {
      this.value = {
        from: null,
        to: null
      }
    }
    if (this.$route.query.filter) {
      this.$route.query.filter.forEach(par => {
        const keyId = Object.keys(par).pop()
        if (Number(keyId) === this.item.id) {
          this.value = par[keyId]
        }
      })
    }
  },
  mounted() {
    document.addEventListener('click', this.closeOption)
    document.addEventListener('openAutocomplete', this.closeOption)
  },

  unmounted() {
    document.removeEventListener('click', this.closeOption)
    document.removeEventListener('openAutocomplete', this.closeOption)
  },

  updated() {
    this.value = this.searchParams.find((param) => String(this.item.id) in param) 
      ? this.searchParams.find((param) => String(this.item.id) in param)[this.item.id] 
      : JSON.parse(JSON.stringify(this.defaultValue))
  }
}
</script>

<template>
  <div 
    class="flex flex-col text-filterField leading-filterField ww-field-max-width"
    :class="{
      'pb-3.5': isMobileVersion,
    }"
  >
    <span v-if="isText" class="flex">
      <VueMultiselect
        v-model="value"
        :options="autocompleteItems[item.id] || []"
        :placeholder="getTranslatedParam(item.name)"
        :showLabels="false"
        @select="onSelect"
        @remove="onRemove"
        @open="onOpenAutocomplete"
      >
        <template v-slot:option="optionProps">
          <div>{{ optionProps.option }}</div>
          <AppClose 
            v-if="optionProps.option === value"
            class="absolute inset-y-0 w-4	h-4 right-4	m-auto"
          />
        </template>
      </VueMultiselect>
    </span>

    <div v-if="isNumber" class="relative h-9">
      <div
        class="flex h-full"
        v-if="item.isPrice"
      >
        <div
          :title="currencySymbol"
          class="flex h-9 justify-between break-words items-center bg-white rounded rounded-r-none border border-grey-light px-3 whitespace-normal text-placeholder overflow-hidden"
        >
          {{ currencySymbol }}
        </div>
        <div class="md:w-2/3 multiselect__tags">
          <input 
            class="w-full focus:outline-none" 
            type="text" 
            v-model="value.from"
            @input="formatNumber"
            :placeholder="fromConstant"
            data-position="from"
          >
        </div>
        <div class="md:w-2/3 multiselect__tags">
          <input 
            class="w-full focus:outline-none" 
            type="text" 
            v-model="value.to"
            @input="formatNumber"
            :placeholder="toConstant"
            data-position="to"
          >
        </div>
      </div>
      <div
        class="h-full"
        v-else
      >
        <div
          ref="numberInput"
          class="h-full break-words w-full flex justify-between items-center bg-white rounded border border-grey-light px-3 whitespace-normal text-placeholder overflow-hidden cursor-pointer"
          :class="{
          'rounded-b-none': isShowField
          }"
          :title="numberFilterPlaceholder"
          @click.prevent="toggleShowField"
        >
          {{ numberFilterPlaceholder }}
          <svg v-if="isShowField" class="fill-current h-4 w-4" viewBox="0 0 20 20">
            <path
              d="M2.582,13.891c-0.272,0.268-0.709,0.268-0.979,0s-0.271-0.701,0-0.969l7.908-7.83c0.27-0.268,0.707-0.268,0.979,0l7.908,7.83c0.27,0.268,0.27,0.701,0,0.969c-0.271,0.268-0.709,0.268-0.978,0L10,6.75L2.582,13.891z"></path>
          </svg>

          <svg v-else class="fill-current h-4 w-4" viewBox="0 0 20 20">
            <path
              d="M17.418,6.109c0.272-0.268,0.709-0.268,0.979,0s0.271,0.701,0,0.969l-7.908,7.83c-0.27,0.268-0.707,0.268-0.979,0l-7.908-7.83c-0.27-0.268-0.27-0.701,0-0.969c0.271-0.268,0.709-0.268,0.979,0L10,13.25L17.418,6.109z"></path>
          </svg>
        </div>
        <div
          class="absolute ww-range z-multiselectZ flex top-100 w-full"
          :class="{
          hidden: !isShowField
        }"
        >
        <div class="md:w-2/3 multiselect__tags">
          <input 
            class="w-full focus:outline-none" 
            type="number" 
            v-model="value.from"
            @input="formatNumber"
            :placeholder="fromConstant"
            data-position="from"
          >
        </div>
        <div class="md:w-2/3 multiselect__tags">
          <input 
            class="w-full focus:outline-none" 
            type="number" 
            v-model="value.to"
            @input="formatNumber"
            :placeholder="toConstant"
            data-position="to"
          >
        </div>
        </div>
      </div>

    </div>
    
    <span v-if="isSelect" class="flex">
      <VueMultiselect
        v-model="value"
        :placeholder="getTranslatedParam(item.name)"
        :clear-on-select="false"
        :close-on-select="!(item.type === 'multiselect')"
        :showLabels="false"
        @select="onSelect"
        @remove="onRemove"
        @open="onOpenAutocomplete"
        label="value"
        track-by="value"
        :preserve-search="true"
        :options="enums"
        :name="item.name"
        :preselect-first="false"
        :multiple="item.type === 'multiselect'"
      />
    </span>
  </div>
</template>

<style scoped>
.ww-field-max-width {
  max-width: 220px;
}

/* стили vue-multiselect*/
:deep(.multiselect__option--selected),
:deep(.multiselect__option--highlight:after),
:deep(.multiselect__option--highlight) {
  background: #f5f8fa !important;
}
:deep(.multiselect__option--highlight) {
  color: black !important;
}
:deep(.multiselect__placeholder), :deep(.multiselect__single) {
  width: 100% !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
}
:deep(.multiselect) {
  min-height: auto !important;
}
:deep(.multiselect__tags) {
  height: 2.25rem !important;
  padding: 6px 2.25rem 0 6px !important;
  min-height: auto !important;
  white-space: nowrap !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
